import React, { useMemo, useCallback } from 'react';
import { useMediaQuery } from '@intigral/hooks';
import useToggleDetailOverlay from '../../../../hooks/useToggleDetailOverlay';
import useShowPPvCta from '../../../../hooks/useShowPPvCta';
import { Button, MovieDetails, Text } from '@intigral/shared';
import { __ } from '../../../../translations';

const PPVSection = ({ item }) => {
    const isMobile = useMediaQuery('(max-width: 924px)');
    const { ppvEvent, logo, textEn } = item || {};
    const { showPpvOverlay } = useToggleDetailOverlay();
    const { isShowBuyNowCta, isStreamingNow, isSubscribed, isRewind, isAvailableSoonCta } = useShowPPvCta(
        ppvEvent || null
    );

    const openPpvDetailsOverlay = useCallback(() => {
        if (!ppvEvent) return;
        showPpvOverlay({
            eventId: ppvEvent.eventId,
            type: 'Home_Screen',
        });
    }, [ppvEvent, showPpvOverlay]);

    const getButtonLabel = useMemo(() => {
        if (!ppvEvent) return '';

        const { price, currency } = ppvEvent;
        const hasPrice = price !== undefined && price !== null && price !== '';

        let key = 'ppv_watch_now';

        if (isStreamingNow && !isSubscribed) {
            key = hasPrice ? 'ppv_watch_now_price' : 'ppv_watch_now';
        } else if (isShowBuyNowCta) {
            key = hasPrice ? 'ppv_buy_now_price' : 'ppv_buy_now';
        } else if (isRewind) {
            key = !isSubscribed && hasPrice ? 'ppv_replay_price' : 'ppv_replay';
        }

        return hasPrice ? __(key, { amount: Number(price), currency }) : __(key);
    }, [ppvEvent, isStreamingNow, isSubscribed, isShowBuyNowCta, isRewind]);

    return (
        <>
            {isMobile ? (
                logo && (
                    <div className="ppv-logo">
                        <img src={logo} alt={ppvEvent?.name || textEn || 'PPV Logo'} />
                    </div>
                )
            ) : (
                <Text as="h2" variant="h2" margin="0" fontWeight="bold">
                    {ppvEvent?.name || textEn}
                </Text>
            )}

            <MovieDetails info={[ppvEvent?.eventStartDate, ppvEvent?.eventStartTime]} />

            {!isAvailableSoonCta && (
                <Button compact onClick={openPpvDetailsOverlay}>
                    {getButtonLabel}
                </Button>
            )}

            <Button compact plain onClick={openPpvDetailsOverlay}>
                {__('infopanel_more_details')}
            </Button>
        </>
    );
};

export default PPVSection;
